import React, { useState } from 'react';
import { useProducts } from '../contexts/ProductContext';
import ProductSlider from './ProductSlider';
import AddProductModal from './AddProductModal';
import EditProductModal from './EditProductModal';
import ProductPreviewModal from './ProductPreviewModal';

const ProductShowcase = () => {
  const { products, deleteProduct } = useProducts();
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [previewingProduct, setPreviewingProduct] = useState(null);

  const handleAddProduct = () => {
    setIsAddModalOpen(true);
  };

  const handleEditProduct = (product) => {
    setEditingProduct(product);
  };

  const handlePreviewProduct = (product) => {
    setPreviewingProduct(product);
  };

  const handleDeleteProduct = (product) => {
    if (window.confirm(`Are you sure you want to delete "${product.name}"?`)) {
      deleteProduct(product.id);
    }
  };

  const handleCloseAddModal = () => {
    setIsAddModalOpen(false);
  };

  const handleCloseEditModal = () => {
    setEditingProduct(null);
  };

  const handleClosePreviewModal = () => {
    setPreviewingProduct(null);
  };

  return (
    <section
      id="products"
      className="scroll-mt-24 py-20 sm:py-24 md:py-32 px-4 sm:px-8 md:px-16 overflow-hidden"
      style={{ backgroundColor: '#F5EFE6' }}
    >
      <div className="max-w-screen-2xl mx-auto flex flex-col gap-12 sm:gap-16">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-6">
          <div className="max-w-full sm:max-w-xl">
            <span className="tracking-widest uppercase text-xs sm:text-sm font-bold block mb-2 sm:mb-4" style={{color: '#C8A96A'}}>The Collection</span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tighter" style={{color: '#3E3E3E'}}>Premium Wooden Furniture</h2>
          </div>
          <button
            onClick={handleAddProduct}
            className="flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-all duration-300 text-sm sm:text-base hover:scale-105"
            style={{backgroundColor: '#C8A96A', color: '#FFFFFF'}}
          >
            <span className="material-symbols-outlined">add</span>
            Add Product
          </button>
        </div>

        {/* Product Slider */}
        {products.length > 0 ? (
          <ProductSlider
            products={products}
            onPreview={handlePreviewProduct}
            onEdit={handleEditProduct}
            onDelete={handleDeleteProduct}
          />
        ) : (
          <div className="text-center py-16">
            <span className="material-symbols-outlined text-6xl text-stone-300 mb-4">chair</span>
            <h3 className="text-xl font-semibold mb-2" style={{color: '#3E3E3E'}}>No products found</h3>
            <p style={{color: '#7A7A7A'}}>Start by adding your first product.</p>
          </div>
        )}
      </div>

      {/* Add Product Modal */}
      <AddProductModal
        isOpen={isAddModalOpen}
        onClose={handleCloseAddModal}
        onAddProduct={useProducts().addProduct}
      />

      {/* Edit Product Modal */}
      <EditProductModal
        isOpen={!!editingProduct}
        onClose={handleCloseEditModal}
        onEditProduct={useProducts().updateProduct}
        product={editingProduct}
      />

      {/* Product Preview Modal */}
      <ProductPreviewModal
        isOpen={!!previewingProduct}
        onClose={handleClosePreviewModal}
        product={previewingProduct}
      />
    </section>
  );
};

export default ProductShowcase;
